import Reflux from "reflux";
import * as URLUtils from "util/URLUtils";
import ApiRoutes from "routing/ApiRoutes";
import { singletonStore, singletonActions } from "logic/singleton";
export const ServerAvailabilityActions = singletonActions(
  "core.ServerAvailability",
  () => Reflux.createActions(["reportError", "reportSuccess"])
);
const ping = (url) => window.fetch(url, {
  method: "GET",
  headers: {
    Accept: "application/json",
    "X-Graylog-No-Session-Extension": "true"
  }
}).then((response) => response.json());
export const ServerAvailabilityStore = singletonStore(
  "core.ServerAvailability",
  () => Reflux.createStore({
    listenables: [ServerAvailabilityActions],
    server: { up: true },
    version: void 0,
    init() {
      this.ping();
    },
    getInitialState() {
      return { server: this.server, version: this.version };
    },
    ping() {
      return ping(URLUtils.qualifyUrl(ApiRoutes.ping().url)).then(
        (response) => {
          if ((response == null ? void 0 : response.version) !== this.version) {
            this.version = response == null ? void 0 : response.version;
            this._trigger();
          }
          return ServerAvailabilityActions.reportSuccess();
        },
        (error) => ServerAvailabilityActions.reportError(error)
      );
    },
    reportError(error) {
      if (this.server.up) {
        this.server = { up: false, error };
        this._trigger();
      }
    },
    reportSuccess() {
      if (!this.server.up) {
        this.server = { up: true };
        this._trigger();
      }
    },
    _trigger() {
      this.trigger({ server: this.server, version: this.version });
    }
  })
);
